<template>
    <field-wrapper
        id="customerDeliveryZip"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerDeliveryZip_input"
            v-model="value"
            type="text"
            name="zip"
            autocomplete="postal-code"
            aria-describedby="customerDeliveryZip_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_delivery_zip");
        },
        value: {
            get() {
                return this.zip || "";
            },
            set(deliveryZip) {
                this.updateCustomer({ deliveryZip });
            }
        },
        errorMessage() {
            if (this.validate && this.error)
                return this.$t(`field_customer_delivery_zip.${this.error}`, 1, {
                    invalidChars: this.invalidChars.join("")
                });
            return null;
        },
        ...mapGetters({
            zip: "customer/getDeliveryZip",
            invalidChars: "customer/getDeliveryZipInvalidChars",
            error: "customer/getDeliveryZipError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
